/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Modal, Select, Form, Row, Col } from "antd";
import { toArray } from "../../../components/util";
import { Utilitaries } from "../../../business";
import { useDeviceSelector } from "../../../V2/components/FormRender/hooks/useDeviceSelector";

const generateQuery = ({ uo }) => {
    const uoWithoutSpace = uo?.trim();

    if (Utilitaries.isEmpty(uoWithoutSpace)) {
        return {};
    }

    return {
        valencia_cliente: uoWithoutSpace,
        qualia_valencia: uoWithoutSpace,
        valencia_autoriza: uoWithoutSpace,
        valencia_origem: uoWithoutSpace,
        valencia_elab: uoWithoutSpace,
        valencia_pci: uoWithoutSpace,
        valencia: uoWithoutSpace,
        valencia_aval: uoWithoutSpace,
        valencia_mon_pdi: uoWithoutSpace,
        valencia_sel: uoWithoutSpace,
        valencia_pdi: uoWithoutSpace,
        resposta_social: uoWithoutSpace,
        valencia_original: uoWithoutSpace,
        valencia_mon_pei: uoWithoutSpace,
        valencia_mon_psei: uoWithoutSpace,
    };
};

export function PopupSocialProcess({ onCancel, process, getFieldDataSource, handleInitProcess, selectedStablishment }) {
    const [uo, setUO] = useState([]);
    const [actions, setActions] = useState([]);
    const [tasks, setTasks] = useState([]);

    const [selectedUO, setSelectedUO] = useState(null);
    const [selectedAction, setSelectedAction] = useState(null);

    const [loading, setLoading] = useState(false);
    const { isDesktop, isTablet } = useDeviceSelector();


    useEffect(() => {
        if (!process) {
            return;
        }
        setSelectedUO(null);
        setSelectedAction(null);

        getFieldDataSource({
            dataSource: "process_mask_options",
            params: { mask_code: process.codigo, idEstabelecimento: selectedStablishment },
        }).then((data) => {
            const list = toArray(data.result);

            const listUO = list
                .filter((it) => !Utilitaries.isEmpty(it.unidade_organica))
                .reduce((acc, item) => {
                    if (
                        !acc.find(
                            (it) => Utilitaries.toString(it.id) === Utilitaries.toString(item.id_unidade_organica)
                        )
                    ) {
                        acc.push({
                            id: item.id_unidade_organica,
                            name: item.unidade_organica?.trim(),
                        });
                    }
                    return acc;
                }, []);
            setUO(listUO);
            setActions(list);
            filterTasks(list);

            let hasEmpty = list.filter((it) => Utilitaries.isEmpty(it.unidade_organica));
            if (listUO.length === 1 && hasEmpty.length === 0) {
                setSelectedUO(listUO[0]);
            }
        });
    }, [process]);

    useEffect(() => {
        if (!Utilitaries.isEmpty(actions)) {
            filterTasks(actions);
        }
    }, [selectedUO]);

    const filterTasks = (actions) => {
        const list = actions.filter(
            (it) =>
                Utilitaries.isEmpty(it?.unidade_organica) ||
                (!Utilitaries.isEmpty(it?.unidade_organica) &&
                    Utilitaries.toString(it?.unidade_organica) === Utilitaries.toString(selectedUO?.name))
        );

        setTasks(list);
    };

    function handleOk() {
        const item = actions.find(
            (it) => Utilitaries.toString(it.nome_externo) === Utilitaries.toString(selectedAction)
        );

        if (item) {
            setLoading(true && !!process);

            const queryParams = generateQuery({
                uo: Utilitaries.toString(selectedUO?.id),
            });

            handleInitProcess(item, queryParams);
        }
    }

    function handleCancel() {
        onCancel(null);
    }

    const customProps = isDesktop
        ? {
              width: "50%",
              style: {
                  minWidth: "768px",
              },
          }
        : isTablet
        ? { width: "80%" }
        : {};

    return (
        <Modal
            title={`Processo - ${process?.codigo_externo} - ${process?.nome_externo}`}
            visible={!!process}
            onOk={handleOk}
            onCancel={handleCancel}
            {...customProps}
            okText="Iniciar"
            okButtonProps={{
                loading: loading,
            }}
        >
            <Form
                labelCol={{
                    xs: { span: 24 },
                    sm: { span: 24 },
                    md: { span: 24 },
                    lg: { span: 8 },
                }}
                wrapperCol={{
                    xs: { span: 24 },
                    sm: { span: 24 },
                    md: { span: 24 },
                    lg: { span: 16 },
                }}
                layout="horizontal"
            >
                <Row gutter={8}>
                    {uo.length > 0 && (
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} xll={8}>
                            <Form.Item label="Unidade orgânica">
                                <Select
                                    showSearch
                                    allowClear
                                    style={{ width: "100%" }}
                                    value={selectedUO?.id}
                                    dropdownMatchSelectWidth={false}
                                    onChange={(value) => {
                                        setSelectedAction("");
                                        if (value) {
                                            const userSelectedUO = uo.find((it) => it?.id?.trim() === value?.trim());
                                            setSelectedUO(userSelectedUO);
                                        } else {
                                            setSelectedUO(null);
                                        }
                                    }}
                                    placeholder="Selecione Unidade orgânica"
                                    // loading={isStablishmentsLoading}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {uo &&
                                        uo.map((item) => (
                                            <Select.Option value={item.id} key={item.id}>
                                                {item.name}
                                            </Select.Option>
                                        ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    )}
                    <Col xs={24} sm={24} md={12} lg={12} xl={12} xll={8}>
                        <Form.Item label="Ação">
                            <Select
                                showSearch
                                allowClear
                                style={{ width: "100%" }}
                                placeholder="Selecione a ação"
                                dropdownMatchSelectWidth={false}
                                value={selectedAction === "" ? undefined : selectedAction}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(value) => setSelectedAction(value)}
                            >
                                {tasks.map(({ nome_externo }) => (
                                    <Select.Option key={nome_externo.trim()}>{nome_externo}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
